import React from "react";

export default function CartSvg(): React.JSX.Element {
  return (
    <svg viewBox="0 0 23 24" id="cart" width="23" height="24" aria-describedby="cart">
      <g fill="none" fillRule="evenodd" stroke="black">
        <g transform="translate(-223 -65) translate(224 66)">
          <circle cx="5" cy="21" r="1" fillRule="nonzero" />
          <circle cx="19" cy="21" r="1" fillRule="nonzero" />
          <circle cx="5" cy="21" r="1" strokeLinecap="square" strokeWidth="2" />
          <circle cx="19" cy="21" r="1" strokeLinecap="square" strokeWidth="2" />
          <path strokeLinecap="square" strokeWidth="2" d="M0 0h3v14c0 1.105.895 2 2 2h16" />
          <path strokeWidth="2" d="M3 4L20 4 18 12 3 12" />
        </g>
      </g>
    </svg>
  );
}
